app.controller('BrowseCommonPageAdvertController', ['$scope', '$rootScope', '$sce', function ($scope, $rootScope, $sce) {

    const dataApiService = $rootScope.service.data_api;

    const dataApiModel = dataApiService.factory.getModel({data_api_id: 'article'});
    const categorySlug = 'page-adverts';
    const tags = $scope.tags;
    const posts = [];
    $scope.page_advert_posts = [];

    dataApiModel.requireCategoryPostList(categorySlug, function () {
        const category = dataApiModel.categories[categorySlug];
        const postSortedList = category ? category.post_sorted_list : null;
        if(!postSortedList){
            return
        }
        for(let i = 0; i < postSortedList.length; i++) {
            const post = postSortedList[i];
            const articleTags = post.article_tags ? post.article_tags : [];

            let haveAll = true;
            for(let j = 0; j < tags.length; j++) {
                const tag = tags[j];
                let found = false;
                for(let k = 0; k < articleTags.length; k++) {
                    const articleTag = articleTags[k];
                    if(articleTag.slug === tag){
                        found = true;
                        break;
                    }
                }
                if(!found){
                    haveAll = false;
                    break;
                }
            }
            if(!haveAll){
                continue;
            }
            post.trusted_html = [];
            if(post.html_encoded_blocks_output){
                for(let j = 0; j < post.html_encoded_blocks_output.length; j++) {
                    let output = post.html_encoded_blocks_output[j];
                    while(true){
                        if(!output){
                            break;
                        }
                        let changed = false;
                        if(output.substring(0, 1) !== "<"){
                            output = output.slice( 1 );
                            changed = true;
                        }
                        if(!output){
                            break;
                        }
                        if(output.charAt(output.length - 1) !== ">"){
                            output = output.slice(0, -1);
                            changed = true;
                        }
                        if(!changed){
                            break;
                        }


                    }
                    if(output){
                        post.trusted_html.push(output)
                    }
                }
            }

            posts.push(post);
        }
        $scope.page_advert_posts = posts;
    });
}]);